// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"1b6539de","160":"057d1a1b","208":"1cc2e820","293":"acbb5f23","453":"64512fd7","516":"35208684","519":"d0ae88f2","917":"01551322","942":"4d65216f","946":"f601696b"}[chunkId] + ".chunk.js";
};